import * as React from "react";
const ThumbsUp = () => {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 3.90397C10.2667 3.90397 10.5 4.00397 10.7 4.20397C10.9 4.40397 11 4.6373 11 4.90397V5.90397C11 5.9623 10.9937 6.0248 10.9812 6.09147C10.9688 6.15813 10.95 6.22063 10.925 6.27897L9.425 9.80397C9.35 9.97063 9.225 10.1123 9.05 10.229C8.875 10.3456 8.69167 10.404 8.5 10.404H4.5C4.225 10.404 3.98958 10.3061 3.79375 10.1102C3.59792 9.91438 3.5 9.67897 3.5 9.40397V4.31647C3.5 4.18313 3.52708 4.05605 3.58125 3.93522C3.63542 3.81438 3.70833 3.70813 3.8 3.61647L6.5125 0.916466C6.6375 0.7998 6.78542 0.728966 6.95625 0.703966C7.12708 0.678966 7.29167 0.708133 7.45 0.791466C7.60833 0.8748 7.72292 0.991466 7.79375 1.14147C7.86458 1.29147 7.87917 1.44563 7.8375 1.60397L7.275 3.90397H10ZM1.5 10.404C1.225 10.404 0.989583 10.3061 0.79375 10.1102C0.597917 9.91438 0.5 9.67897 0.5 9.40397V4.90397C0.5 4.62897 0.597917 4.39355 0.79375 4.19772C0.989583 4.00188 1.225 3.90397 1.5 3.90397C1.775 3.90397 2.01042 4.00188 2.20625 4.19772C2.40208 4.39355 2.5 4.62897 2.5 4.90397V9.40397C2.5 9.67897 2.40208 9.91438 2.20625 10.1102C2.01042 10.3061 1.775 10.404 1.5 10.404Z"
        fill="#A67F40"
      />
    </svg>
  );
};
export default ThumbsUp;
